var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-7"},[(_vm.$store.getters['app/alternativeAuth'])?_c('AlternativeAuthForm'):_c('AuthForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }